import classNames from 'classnames'
import type { FileExtension } from '../../../shared/domain/files/fileExtensions.no-deps'
import { FileExtensionIcon } from './FileExtensionIcon'
import React from 'react'
import { abbreviateFileSize } from '../../../shared/lib/fileSize'
import { Spinner } from './Spinner'

export function FileDetails(props: {
    disabled: boolean
    fileName: string
    fileSize: number
    fileExtension: FileExtension
    loading?: boolean
    errored?: boolean
    onClear: () => void
    onMounted?: () => void
}) {
    React.useEffect(() => props.onMounted && props.onMounted(), [])

    return (
        <div
            className={classNames({
                AppCore__ui__FileDetails: true,
                disabled: props.disabled,
                errored: props.errored,
            })}
        >
            <div className="AppCore__ui__FileDetails-inner">
                <div className="AppCore__ui__FileDetails-icon">
                    {(props.loading && (
                        <div className="AppCore__ui__FileDetails-spinner">
                            <Spinner size={20} />
                        </div>
                    )) || <FileExtensionIcon fileExtension={props.fileExtension} isGrayscale={props.disabled} />}
                </div>
                <div className="AppCore__ui__FileDetails-info">
                    <span>
                        <zaptic-ellipsis>{props.fileName}</zaptic-ellipsis>
                    </span>
                    <span className="AppCore__ui__FileDetails-fileSize">{abbreviateFileSize(props.fileSize)}</span>
                </div>
                {!props.disabled && (
                    <div className="AppCore__ui__FileDetails-actions">
                        <button onClick={props.onClear}>
                            <img src="/shared/images/bin-grey-small.svg"></img>
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}
